import styled from "styled-components";

export const FlexCenterTemplate  = `
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    gap: 20px;
`

export const FlexCenter = styled.section`
  ${FlexCenterTemplate}
`